<template>
  <div>
    <p class="cm-mg-p-wzd">
      2.1 {{ $t('common_words.geo_position_info_sensor') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-4">
        <fg-input
          type="number"
          :label="`${$t('common_words.latitude')}: `"
          v-model="model.latitude"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="number"
          :label="`${$t('common_words.longitude')}: *`"
          v-model="model.longitude"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <div
            ref="map"
            class="map"
            v-if="renderComponent"
            style="height: 500px"
          ></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          >
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :title="$t('common_words.clear_measurement')"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      model: {
        latitude: null,
        longitude: null,
      },
      map: null,
      renderComponent: true,
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinArcgisMap, mixinMasters],
  methods: {
    geoMap() {
      this.center.lat = this.model.latitude
        ? parseFloat(this.model.latitude)
        : this.center.lat;
      this.center.lng = this.model.longitude
        ? parseFloat(this.model.longitude)
        : this.center.lng;

      this.loadMap();
    },

    loadMap() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadBaseMap(null, true);

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 11%';
        }, 10);
      });
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillSensorForm', 'secondStep');
        return res;
      });
    },
  },

  created() {
    this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.latitude = editForm.latitude;
      this.model.longitude = editForm.longitude;
    }

    this.geoMap();
  },
};
</script>
<style></style>
